import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class LevelTwoTwo extends Component {
    render() {
        const {tagName,ServiceName,ServiceDesc,ButtonText, BgColor} = this.props;
        return (
            <div className={"card half-card "+ BgColor}>
                <div className="column white-text">
                    <span className='text-uppercase'>{tagName}</span>
                    <p className="block-heading">{ServiceName}</p>
                    <p>{ServiceDesc}</p>
                    <NavLink to="/" className="white-bordered-button">{ButtonText}</NavLink>
                </div>
            </div>
        );
    }
}

export default LevelTwoTwo;